export default __webpack_public_path__ + "./image/6fa7f1cb81f80a356eff68a71f607499.png";